import Zoom from "./ZoomControls.js";
import { auditTime, map, distinctUntilChanged } from "rxjs/operators";

const _debug = false;

const _storagePrefix = "goobi.imageView.persistence.";

export default class ViewPersistence {

    /**
     * 
     * @param {Zoom} zoom 
     * @param {String} persistenceId 
     */
    constructor(zoom, persistenceId) {
        this.zoom = zoom;
        this.persistenceId = persistenceId;
        this.latestPosition = undefined;

        this.zoom.imageView.onOpened.subscribe( () => {
            const position = this.restore();
            if(position) {
                this.zoom.initialPosition = position;
                this.zoom.setPosition(position);
            }
            this.zoom.imageView.onUpdate
            .pipe( 
                auditTime(100),
                map(() => this.zoom.getPosition()),
                distinctUntilChanged((a, b) => _positionEqual(a, b))
            )
            .subscribe(pos => this.store(pos)); 
        });
    }

    store(position) {
        position ?? this.zoom.getPosition();
        this.latestPosition = position;
        if(_debug)console.log("store position ", position);
        _writeToStorage(position, this.persistenceId); 
    }

    restore() {
        const position = _readFromStorage(this.persistenceId);
        if(_debug)console.log("restore position ", position);
        if(position) {
            this.zoom.setPosition(position);
        }
    }


}

function _writeToStorage(location, persistenceId) {
    if(location && persistenceId) {
        const string = JSON.stringify(location);
        window.sessionStorage.setItem(_storagePrefix + persistenceId, string);
    }

}

function _readFromStorage(persistenceId) {
    const string = window.sessionStorage.getItem(_storagePrefix + persistenceId);
    if(string && string.length) {
        try {
            return JSON.parse(string);
        } catch(e) {
            console.error("Error parsing image view persistence information ", string, e);
            return undefined;
        }
    } else {
        return undefined;
    }
}

function _positionEqual(a, b) {
    return a.zoom === b.zoom && a.rotation === b.rotation && _almostEqual(a.center?.x, b.center?.x) && _almostEqual(a.center?.y, b.center?.y);
}

function _almostEqual(a, b, decimals = 12) {
    if(a === undefined && b === undefined) {
        return true;
    } else {
        const factor = 10 ** decimals;
        return Math.round(a * factor) === Math.round(b * factor);
    }
}